<script setup>
import { ref, defineProps, defineEmits, computed } from 'vue';
import IncheckReferenceService from '../../../services/IncheckReferenceService';
/* Emits */
const emits = defineEmits(['newNoMatch', 'busy']);
/* Props */
const props = defineProps({
    product: {required: true}
});
/* Data */
const submitStatus = ref('void');
const { setNoMatchInIncheckReference } = IncheckReferenceService();
/* Computed */
const setNoMatchButtonClasses = computed( () =>
{
    switch(submitStatus.value)
    {
        case 'void': case 'loading': case 'error': default:
            return `bg-red-500 hover:bg-red-700`;
        case 'success':
            return `bg-green-500 hover:bg-green-700`;
    }
});
const setNoMatchButtonContet = computed( () => 
{
    switch(submitStatus.value)
    {
        case 'loading':
            return `<svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>`;
        case 'success':
            return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 fill-current text-white"><path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"/></svg>';
        case 'error':
            return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 fill-current text-white"><path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"/></svg>`;
        case 'void': default:
            return 'No match';
    }
});
/* Methods */
const setNoMatch = async () =>
{
    if(submitStatus.value === 'loading') return;

    submitStatus.value = 'loading';
    // Niente timer che riabilita il pulsante a meta' richiesta: la richiesta ha
    // il suo tetto, e riabilitarlo prima permetteva di mandarne una seconda
    // mentre la prima era ancora in volo.
    // Chi ospita il pulsante deve sapere che c'e' una scrittura in volo: chiudere
    // adesso non la annulla, la lascia arrivare senza che nessuno aggiorni la
    // riga.
    emits('busy', true);

    let done = null;

    try
    {
        // No match is local-only now: no placeholder product is created on the
        // Gateway, the product travels inline in the inventory payload.
        done = await setNoMatchInIncheckReference(props.product.incheck_reference.id, {
            no_match: true,
            product_name: props.product.name,
            formulator_name: props.product.formulator?.name ?? null,
            new_results: []
        });
    }
    catch(e)
    {
        // Un rifiuto del backend — il periodo chiuso da un report, per esempio —
        // arriva come promessa respinta: senza raccoglierlo il pulsante tornava
        // attivo dopo cinque secondi senza aver detto niente, e sembrava che il
        // clic non fosse arrivato.
    }

    // Prima di annunciare l'esito: chi ascolta chiude il modale, e un annuncio
    // dopo la chiusura arriverebbe a un componente che non c'e' piu'.
    emits('busy', false);

    // La riga aggiornata e' la sola prova che la scrittura sia andata a segno:
    // il servizio restituisce comunque qualcosa anche quando non lo e'.
    if(done?.incheck_reference)
    {
        submitStatus.value = 'success';
        setTimeout( () => submitStatus.value = 'void', 2000);

        return emits('newNoMatch', true);
    }

    submitStatus.value = 'error';
    setTimeout( () => submitStatus.value = 'void', 2000);
};
</script>
<template>
    <button 
        @click.prevent="setNoMatch"
        class="px-5 py-3 font-medium leading-5 text-center text-white rounded lg:mt-0 duration-300 lg:w-auto"
        :class="setNoMatchButtonClasses"
        v-html="setNoMatchButtonContet"
        :disabled="submitStatus !== 'void'">
    </button>
</template>